import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import React from 'react';

import { HeaderSkeleton } from './components/Skeleton';

/**
 * Section: Header
 *
 * @param components
 * @param hasData
 * @param isFetching
 * @param isLoading
 * @param title
 * @returns {Element}
 * @constructor
 */
export function Header({ components, hasData, isFetching, isLoading, title }) {
  const { LeftComponent, RightComponent } = components;

  return (
    <ErrorHandler location="src/shared/ui/layouts/Dashboard/sections/Header/Header.jsx">
      <div id="layout-dashboard-header">
        <Flex>
          <div id="layout-dashboard-header-left">
            <div id="layout-dashboard-header-title">
              <Heading offset={0}>{title}</Heading>
            </div>
            {LeftComponent}
          </div>
          {!isLoading && (
            <div id="layout-dashboard-header-right">
              {isFetching ? (
                <HeaderSkeleton />
              ) : (
                <React.Fragment>
                  {hasData && (
                    <Grid>
                      <Grid.Col
                        span={{
                          xs: '100%',
                        }}
                      >
                        {RightComponent}
                      </Grid.Col>
                    </Grid>
                  )}
                </React.Fragment>
              )}
            </div>
          )}
        </Flex>
      </div>
    </ErrorHandler>
  );
}
